/**
 * Google GA43 tracking functions: 
 * 
 */

declare const ga: any;
import { logger } from "./utils";
import { reservaD } from "./variables";

declare const PAG_ATRIB: string;
declare const GOOGLE_TAG: string;

declare global {
  interface Window {
    dataLayer:any;
  }
}

let dataLayer = window.dataLayer || [];


let ga4_uid = "";
let ga5_uid = "";

function gtag(...args: any[]): void {
	// @ts-ignore
	dataLayer.push(arguments);
}

async function google_initialise() {

  setGoogleTracker();
	setAFTracker();

}


function google_send_search(){

  try {
    gtag("send", {
      hitType: "event",
      eventCategory: "Form",
      eventAction: "buscar",
      eventLabel: PAG_ATRIB + " - " + reservaD[5],
    });
		logger("Search sent to GA", "log");
  } catch (err) {
    logger("Error sending search to GA: " + err, "error");
  }

}


function google_send_detail(){

  try {
		gtag("send", {
			hitType: "event",
			eventCategory: "Form",
			eventAction: "Seleccionar Vehiculo",
			eventLabel: PAG_ATRIB + " - " + reservaD[20],
		})
		logger("Detail sent to GA", "log");
	} catch (err) {
		logger("Error sending search to GA: " + err, "error");
	}

}


function google_send_book(res_id: string){

  try {
		gtag("send", {
			hitType: "event",
			eventCategory: "Form",
			eventAction: "Reservar",
			eventLabel: PAG_ATRIB + " - " + res_id,
		});
		logger("Reserva sent to GA", "log");
	} catch (err) {
		logger("Error sending book to GA: " + err, "error");
	}

}

function setGoogleTracker(){

	logger("Searching for gtag", "log")

 	ga4_uid = "0";

	const gclidPromise = new Promise(resolve => {
		gtag('get', GOOGLE_TAG, 'client_id', resolve);
	});
	  
	gclidPromise.then((gclid) => {
		ga4_uid = gclid?.toString() ?? "";
		reservaD[85] = ga4_uid;
		logger("GA4 reset: " + reservaD[85], "log")

	})
	.catch((err) => {
		logger("Error getting gclid: " + err, "error");
		reservaD[85] = ga4_uid;
	});

}

function setAFTracker(){

	ga5_uid = "0";

	if ( typeof localStorage.getItem("ga5_uid") !== undefined  
    && localStorage.getItem("ga5_uid") !== null  ) {
	
		ga5_uid = localStorage.getItem("ga5_uid") ?? ""; 
	
	} else {

		let hex = "";
		for (let i = 0; i < 3; i++){
			const random = Math.random();
			const bit = (random * 16) | 0;
			hex += (bit).toString(16);
		 };

		ga5_uid = "AF" + Date.now() + hex;
		localStorage.setItem("ga5_uid", ga5_uid);
	}

	reservaD[96] = ga5_uid;
	logger("GA5 set: " + reservaD[96], "log");
	
	dataLayer.push({
		'furauto_userid' : ga5_uid
	});

}


export { google_initialise, google_send_search, google_send_detail, google_send_book, ga4_uid, ga5_uid }
